import { FC } from "react"

import TopLeadBreakdown from "../../leads/charts/top-lead-breakdown"
import ChartWithStats from "../../chart-with-stats"
import withLazyLoad from "../../with-lazy-load"

interface Props {
  orgId?: string
}

const LazyTopLeadBreakdown = withLazyLoad(TopLeadBreakdown)
const LazyChartWithStats = withLazyLoad(ChartWithStats)

const Charts: FC<Props> = ({ orgId }) => {
  return (
    <>
      <LazyTopLeadBreakdown
        key={`top-lead-breakdown-${orgId}`}
        title="Top Lead Breakdown"
        range={30}
        orgId={orgId}
        loid={undefined}
        contentHeight="420px"
        hasRangeFilter
      />
      <LazyChartWithStats
        key={`subscription-email-performance-${orgId}`}
        title="Subscription email performance"
        type="emails"
        orgId={orgId}
        defaultDays={30}
      />
    </>
  )
}

export default Charts
